import { render, staticRenderFns } from "./AgendaCreate.vue?vue&type=template&id=d0005fac"
import script from "./AgendaCreate.vue?vue&type=script&lang=js"
export * from "./AgendaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports